/* Floravita direct checkout and Doran handoff. No payment data is collected here. */
(function () {
  'use strict';
  if (window.fvQuickBuyReady) return;
  window.fvQuickBuyReady = true;
  var config = {}, pending = false, navigationInProgress = false, observer;
  var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function navigate(url) { navigationInProgress = true; window.location.assign(url); }
  function friendlyError(error) {
    if (error && (error.name === 'AbortError' || error.name === 'TypeError')) return 'No hemos podido conectar. Revisa tu conexión y vuelve a intentarlo.';
    return error && error.message || 'No hemos podido continuar. Vuelve a intentarlo.';
  }
  function readConfig() {
    var el = document.getElementById('FvQuickBuyConfig');
    try { config = el ? JSON.parse(el.textContent) : { enabled: true }; } catch (e) { config = { enabled: true }; }
    document.body.classList.toggle('fv-qb-enhanced', config.enabled !== false);
    document.querySelectorAll('[data-fv-qb-label]').forEach(function (el) { el.textContent = config.label || 'Comprar Ahora'; });
  }
  function sourceForm(root) {
    var id = root.getAttribute('data-fv-qb-source');
    return id && document.getElementById(id) || root.closest('form') || root.querySelector('form[data-fv-qb-form]');
  }
  function selection(root) {
    var form = sourceForm(root), data = form ? new FormData(form) : new FormData();
    var id = data.get('id') || root.getAttribute('data-fv-qb-variant');
    var quantity = Number(data.get('quantity') || 1);
    if (!id || !/^\d+$/.test(String(id))) throw new Error('Selecciona una opción del producto antes de continuar.');
    if (!Number.isInteger(quantity) || quantity < 1) throw new Error('Introduce una cantidad válida, igual o superior a una unidad.');
    if (form && !form.reportValidity()) throw new Error('Revisa las opciones y la cantidad del producto.');
    data.set('id', String(id)); data.set('quantity', String(quantity));
    data.delete('return_to');
    return { form: form, data: data, id: String(id), quantity: quantity };
  }
  function setBusy(root, button, busy, notify) {
    root.classList.toggle('is-busy', busy);
    if (busy) {
      button.setAttribute('aria-busy', 'true'); button.setAttribute('aria-disabled', 'true');
      if (button.tagName === 'BUTTON') button.disabled = true;
      var label = button.querySelector('[data-fv-qb-label]');
      if (label) label.textContent = notify ? config.notifyLoading || 'Abriendo disponibilidad…' : config.loading || 'Preparando tu compra…';
    } else {
      button.removeAttribute('aria-busy'); button.removeAttribute('aria-disabled');
      if (button.tagName === 'BUTTON') button.disabled = false;
      var label2 = button.querySelector('[data-fv-qb-label]');
      if (label2) label2.textContent = config.label || 'Comprar Ahora';
    }
  }
  function message(root, text, cartLink) {
    var el = root.querySelector('[data-fv-qb-message]');
    if (!el) return;
    el.textContent = text || ''; el.hidden = !text;
    if (cartLink) {
      var link = document.createElement('a');
      link.href = config.cartUrl || routeRoot + 'cart'; link.textContent = 'Revisar mi carrito'; el.appendChild(link);
    }
  }
  async function request(url, options) {
    var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetch(url, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal }, options || {}));
      var data;
      try { data = await response.json(); } catch (e) { data = {}; }
      return { response: response, data: data };
    } finally { clearTimeout(timeout); }
  }
  async function productState(root) {
    var handle = root.getAttribute('data-fv-qb-handle');
    if (!handle) throw new Error('No hemos podido identificar el modelo. Abre su ficha y vuelve a intentarlo.');
    var result = await request(routeRoot + 'products/' + encodeURIComponent(handle) + '.js', { cache: 'no-store' });
    if (!result.response.ok || !Array.isArray(result.data.variants)) throw new Error('No hemos podido consultar la disponibilidad. Vuelve a intentarlo en unos instantes.');
    return result.data;
  }
  function variantFrom(product, id) { return product.variants.find(function (v) { return String(v.id) === String(id); }); }
  function stockButton(root) {
    var pid = root.getAttribute('data-fv-qb-product');
    var regions = Array.from(document.querySelectorAll('[data-dr="back-in-stock-inline-button"]'));
    var region = regions.find(function (el) { return !pid || el.getAttribute('data-product-id') === pid; });
    return region && region.querySelector('button,[role="button"]');
  }
  function clearNotifyQuery() {
    var url = new URL(window.location.href);
    if (url.searchParams.has('fv_notify')) {
      url.searchParams.delete('fv_notify');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }
  }
  function openAlert(root, id) {
    var url = new URL(root.getAttribute('data-fv-qb-url') || window.location.href, window.location.origin);
    var here = window.location.pathname.replace(/\/$/, '');
    if (url.pathname.replace(/\/$/, '') !== here) {
      url.searchParams.set('fv_notify', '1'); url.searchParams.set('variant', id); url.hash = 'fv-stock-alert';
      navigate(url.href); return Promise.resolve();
    }
    message(root, 'Abriendo el formulario de disponibilidad…');
    return new Promise(function (resolve) {
      var settled = false, localObserver, alertTimer;
      function finish(ok) {
        if (settled) return; settled = true;
        if (localObserver) localObserver.disconnect();
        clearTimeout(alertTimer);
        if (ok) { message(root, ''); clearNotifyQuery(); }
        else {
          message(root, 'El formulario tarda en cargar. Puedes usar «Avisarme cuando esté disponible» debajo de la compra o contactar con Floravita.');
          var region = document.getElementById('fv-stock-alert');
          if (region) region.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }
        resolve();
      }
      function attempt() {
        if (settled) return;
        var button = stockButton(root);
        if (!button) return;
        button.click(); finish(true);
      }
      localObserver = new MutationObserver(attempt);
      localObserver.observe(document.body, { childList: true, subtree: true });
      alertTimer = setTimeout(function () { finish(false); }, 12000);
      attempt();
    });
  }
  async function buy(root, button) {
    if (pending || navigationInProgress || config.enabled === false) return;
    pending = true;
    var posted = false;
    message(root, '');
    setBusy(root, button, true, root.getAttribute('data-fv-qb-available') !== 'true');
    try {
      var selected = selection(root);
      if (root.getAttribute('data-fv-qb-options') === 'true' && !root.getAttribute('data-fv-qb-source') && !root.closest('form[data-product-form]')) {
        navigate(root.getAttribute('data-fv-qb-url')); return;
      }
      if (root.getAttribute('data-fv-qb-available') !== 'true' || selected.id !== root.getAttribute('data-fv-qb-variant')) {
        var product = await productState(root);
        var current = variantFrom(product, selected.id);
        if (!current) throw new Error('Esta opción no está disponible. Consulta las opciones del modelo.');
        if (!current.available) { await openAlert(root, selected.id); return; }
      }
      setBusy(root, button, true, false);
      posted = true;
      var result = await request(routeRoot + 'cart/add.js', { method: 'POST', body: selected.data });
      if (result.response.ok) {
        navigate(config.checkoutUrl || routeRoot + 'checkout');
        return;
      }
      if (result.response.status === 422) {
        var latest = await productState(root), variant = variantFrom(latest, selected.id);
        if (variant && !variant.available) { await openAlert(root, selected.id); return; }
      }
      var detail = result.data.description || result.data.message;
      if (!detail && result.data.errors) detail = typeof result.data.errors === 'string' ? result.data.errors : Object.values(result.data.errors).join(' ');
      message(root, typeof detail === 'string' ? detail : 'No se ha podido añadir esta cantidad. Revisa tu carrito o prueba con una cantidad menor.', true);
    } catch (error) {
      message(root, posted ? 'No hemos podido confirmar la operación. Revisa tu carrito antes de volver a intentarlo.' : friendlyError(error), posted);
    } finally {
      if (!navigationInProgress) { pending = false; setBusy(root, button, false, false); }
    }
  }
  function productLink(link) {
    try {
      var url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      var match = url.pathname.match(/\/products\/([^/]+)\/?$/);
      return match ? { url: url, handle: decodeURIComponent(match[1]) } : null;
    } catch (e) { return null; }
  }
  function enhanceOtherCards() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      if (link.closest('.fv-qb,nav,header,footer,[data-cart-item],.cart__row,.fvc-item') || link.hash) return;
      var target = productLink(link);
      if (!target) return;
      var holder = link.closest('article,.product-card,.list-view-item,.grid-view-item');
      if (!holder && link.matches('.btn,.button,.fv-home__button,.hero__btn')) holder = link.parentElement;
      if (holder && holder.closest('a')) {
        holder = holder.closest('a').parentElement;
        if (!holder || holder.querySelectorAll('a[href*="/products/"]').length !== 1) return;
      }
      if (!holder || holder.querySelector('[data-fv-qb]') || holder.closest('.fv-product-shell')) return;
      var wrap = document.createElement('div'), action = document.createElement('a'), label = document.createElement('span'), note = document.createElement('span'), status = document.createElement('p');
      wrap.className = 'fv-qb fv-qb--compact'; wrap.setAttribute('data-fv-qb', '');
      wrap.setAttribute('data-fv-qb-handle', target.handle); wrap.setAttribute('data-fv-qb-url', target.url.pathname);
      wrap.setAttribute('data-fv-qb-available', 'unknown'); wrap.setAttribute('data-fv-qb-variant', target.url.searchParams.get('variant') || '');
      action.href = target.url.href; action.className = 'fv-qb__button'; action.setAttribute('data-fv-qb-resolve', '');
      label.setAttribute('data-fv-qb-label', ''); label.textContent = config.label || 'Comprar Ahora'; action.appendChild(label);
      note.className = 'fv-qb__note'; note.textContent = 'Consulta disponibilidad y accede al pago';
      status.className = 'fv-qb__message'; status.setAttribute('data-fv-qb-message', ''); status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.hidden = true;
      wrap.append(action, note, status); holder.appendChild(wrap);
    });
  }
  async function resolveLink(root, button) {
    if (pending || navigationInProgress) return;
    pending = true; setBusy(root, button, true, true); message(root, '');
    try {
      var p = await productState(root);
      var requested = root.getAttribute('data-fv-qb-variant');
      var v = requested ? variantFrom(p, requested) : p.variants.find(function (variant) { return variant.available; }) || p.variants[0];
      if (!v) throw new Error('Este modelo no tiene una opción disponible.');
      root.setAttribute('data-fv-qb-product', String(p.id)); root.setAttribute('data-fv-qb-variant', String(v.id)); root.setAttribute('data-fv-qb-available', String(v.available));
      if (p.variants.length > 1 && !requested) { navigate(root.getAttribute('data-fv-qb-url')); return; }
      pending = false; setBusy(root, button, false, false);
      await buy(root, button);
    } catch (error) { message(root, friendlyError(error)); }
    finally { if (!navigationInProgress) { pending = false; setBusy(root, button, false, false); } }
  }
  document.addEventListener('submit', function (event) {
    var button = event.submitter, form = event.target;
    if (config.enabled === false) return;
    if (pending && form.matches('form[action*="/cart/add"]')) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (!button || !button.matches('[data-fv-qb-submit]')) return;
    var root = button.closest('[data-fv-qb]');
    if (!root) return;
    event.preventDefault(); event.stopImmediatePropagation(); buy(root, button);
  }, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-fv-qb-notify],[data-fv-qb-resolve]');
    if (!button || config.enabled === false) return;
    var root = button.closest('[data-fv-qb]');
    if (!root) return;
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (button.hasAttribute('data-fv-qb-resolve')) resolveLink(root, button); else buy(root, button);
  }, true);
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted && (pending || navigationInProgress)) return;
    pending = false; navigationInProgress = false;
    document.querySelectorAll('[data-fv-qb] .fv-qb__button').forEach(function (button) { setBusy(button.closest('[data-fv-qb]'), button, false, false); });
  });
  function init() {
    readConfig();
    if (config.enabled === false) return;
    enhanceOtherCards();
    var scheduled = false;
    observer = new MutationObserver(function () {
      if (scheduled) return; scheduled = true;
      window.requestAnimationFrame(function () { scheduled = false; enhanceOtherCards(); });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    var params = new URL(window.location.href).searchParams;
    if (params.get('fv_notify') === '1') {
      var root = document.querySelector('.product-single__meta [data-fv-qb],.fv-qb--detail[data-fv-qb]');
      if (root) openAlert(root, params.get('variant') || root.getAttribute('data-fv-qb-variant'));
    }
  }
  document.addEventListener('shopify:section:load', function () { readConfig(); if (config.enabled !== false) enhanceOtherCards(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}());
